import { Button, Modal } from 'antd';
import { strings } from '../../../lang';

export interface AssignmentChangedModalProps {
  open: boolean;
  onRefresh: () => void;
}

export const AssignmentChangedModal = ({ open, onRefresh }: AssignmentChangedModalProps) => (
  <Modal
    title={strings.assignmentChanged.title}
    centered
    closable={false}
    maskClosable={false}
    keyboard={false}
    open={open}
    footer={[
      <Button key="refresh" type="primary" onClick={onRefresh}>
        {strings.assignmentChanged.refreshButton}
      </Button>,
    ]}
  >
    <p>{strings.assignmentChanged.body}</p>
  </Modal>
);
